"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PAYMENT_METHOD_ERROR = exports.UPDATE_PAYMENT_METHOD_SUCCESS = exports.UPDATE_PAYMENT_METHOD_VALUES = exports.UPDATE_PAYMENT_METHOD = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = customer;
exports.cleanError = cleanError;
exports.getCustomer = getCustomer;
exports.createCustomer = createCustomer;
exports.updateCustomer = updateCustomer;
exports.updateCustomerAddress = updateCustomerAddress;
exports.createOrUpdateCustomer = createOrUpdateCustomer;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _utils = require("utils");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_ERROR = "ms/customer/clear_error";
var GET = "ms/customer/get";
var GET_SUCCESS = "ms/customer/get_success";
var GET_FAIL = "ms/customer/get_fail";

var CREATE = "ms/customer/create";
var CREATE_SUCCESS = "ms/customer/create_success";
var CREATE_FAIL = "ms/customer/create_fail";

var UPDATE = "ms/customer/update";
var UPDATE_SUCCESS = "ms/customer/update_success";
var UPDATE_FAIL = "ms/customer/update_fail";

var UPDATE_ADDRESS = "ms/customer/address/update";
var UPDATE_ADDRESS_SUCCESS = "ms/customer/address/update_success";
var UPDATE_ADDRESS_FAIL = "ms/customer/address/update_fail";

var UPDATE_PAYMENT_METHOD = exports.UPDATE_PAYMENT_METHOD = "ms/customer/update_payment_method";
var UPDATE_PAYMENT_METHOD_VALUES = exports.UPDATE_PAYMENT_METHOD_VALUES = "ms/customer/update_payment_method_values";
var UPDATE_PAYMENT_METHOD_SUCCESS = exports.UPDATE_PAYMENT_METHOD_SUCCESS = "ms/customer/update_payment_method_success";
var UPDATE_PAYMENT_METHOD_ERROR = exports.UPDATE_PAYMENT_METHOD_ERROR = "ms/customer/update_payment_method_error";

var _ = require("underscore");

var errorMessageFormat = function errorMessageFormat(error) {
  if (error.code && error.code === "CANNOT_UPDATE_TAX_STATUS") {
    return "The changes in address affect applicable tax. Resubscribe to update your billing address.";
  } else {
    return error.msg || error.code || error.error;
  }
};

var initialState = {
  customer: null,

  getting: false,
  creating: false,

  createError: null,
  getError: null
};

// Reducer

function customer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET:
      return (0, _extends3.default)({}, state, {
        getting: true,
        getError: null
      });

    case GET_SUCCESS:
      return (0, _extends3.default)({}, state, {
        getting: false,
        customer: action.result,
        updateError: null
      });

    case GET_FAIL:
      return (0, _extends3.default)({}, state, {
        getting: false,
        getError: action.error
      });

    case CREATE:
      return (0, _extends3.default)({}, state, {
        creating: true,
        createError: null
      });

    case CREATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        creating: false,
        createError: null,
        customer: action.result
      });

    case CREATE_FAIL:
      return (0, _extends3.default)({}, state, {
        creating: false,
        createError: action.error
      });

    case UPDATE:
      return (0, _extends3.default)({}, state, {
        updating: true,
        updateError: null,
        error: null
      });

    case UPDATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updating: false,
        updateError: null,
        customer: action.result
      });

    case UPDATE_FAIL:
      return (0, _extends3.default)({}, state, {
        updating: false,
        updateError: action.error
      });

    case UPDATE_ADDRESS:
      return (0, _extends3.default)({}, state, {
        updatingAddress: true,
        updateError: null
      });

    case UPDATE_ADDRESS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updatingAddress: false,
        updateError: null,
        customer: action.result
      });

    case UPDATE_ADDRESS_FAIL:
      return (0, _extends3.default)({}, state, {
        updatingAddress: false,
        updateError: errorMessageFormat(action.error)
      });

    case UPDATE_PAYMENT_METHOD:
      return (0, _extends3.default)({}, state, {
        updatingPaymentMethod: true
      });

    case UPDATE_PAYMENT_METHOD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updatingPaymentMethod: false
      });
    case UPDATE_PAYMENT_METHOD_VALUES:
      return (0, _extends3.default)({}, state, {
        customer: (0, _extends3.default)({}, state.customer, {
          paymentMethod: action.result
        })
      });
    case UPDATE_PAYMENT_METHOD_ERROR:
      return (0, _extends3.default)({}, state, {
        updatingPaymentMethod: false,
        error: action.payload
      });
    case CLEAR_ERROR:
      return (0, _extends3.default)({}, state, {
        updateError: null,
        error: null
      });

    default:
      return state;
  }
}

// Action creators

function cleanError() {
  return {
    type: CLEAR_ERROR
  };
}

function getCustomer() {
  return function (dispatch, getState) {
    if (getState().auth.loggedIn) {
      return dispatch({
        types: [GET, GET_SUCCESS, GET_FAIL],
        promise: function promise(client) {
          return client.get("/v1/payments/customers/self").then(function (customer) {
            return _.isEmpty(customer) ? null : customer;
          });
        }
      });
    } else {
      if (__SERVER__) {
        return dispatch(function () {});
      } else {
        return _bluebird2.default.reject(new Error("User not logged in"));
      }
    }
  };
}

function createCustomer(_ref) {
  var name = _ref.name,
      company = _ref.company,
      address1 = _ref.address1,
      address2 = _ref.address2,
      postalCode = _ref.postalCode,
      country = _ref.country,
      countryCode = _ref.countryCode,
      vatNo = _ref.vatNo,
      vatSignature = _ref.vatSignature,
      nonce = _ref.nonce,
      deviceData = _ref.deviceData,
      city = _ref.city,
      state = _ref.state,
      mainDivision = _ref.mainDivision;

  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: function promise(client) {
      return client.post("/v1/payments/customers", {
        data: _ramda2.default.pickBy(_ramda2.default.complement(_ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil)), (0, _extends3.default)({
          name: name,
          company: company,
          address1: address1,
          address2: address2,
          postalCode: postalCode,
          country: country,
          countryCode: countryCode,
          vatNo: vatNo,
          vatSignature: vatSignature,
          paymentMethodNonce: nonce,
          deviceData: deviceData,
          city: city,
          state: state
        }, mainDivision && { mainDivision: mainDivision }))
      });
    }
  };
}

function updateCustomer(_ref2) {
  var name = _ref2.name,
      company = _ref2.company,
      address1 = _ref2.address1,
      address2 = _ref2.address2,
      postalCode = _ref2.postalCode,
      country = _ref2.country,
      countryCode = _ref2.countryCode,
      vatNo = _ref2.vatNo,
      vatSignature = _ref2.vatSignature,
      nonce = _ref2.nonce,
      threeDNonce = _ref2.threeDNonce,
      deviceData = _ref2.deviceData,
      city = _ref2.city,
      state = _ref2.state,
      mainDivision = _ref2.mainDivision;

  var data = _ramda2.default.pickBy(_ramda2.default.complement(_ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil)), (0, _extends3.default)({
    name: name,
    company: company,
    address1: address1,
    address2: address2,
    postalCode: postalCode,
    country: country,
    countryCode: countryCode,
    city: city,
    state: state
  }, mainDivision && { mainDivision: mainDivision }, vatNo && {
    vatNo: vatNo
  }, vatSignature && {
    vatSignature: vatSignature
  }, {
    paymentMethodNonce: nonce,
    paymentMethod3DNonce: threeDNonce,
    deviceData: deviceData
  }));

  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: function promise(client) {
      return client.put("/v1/payments/customers", { data: data });
    }
  };
}

function updateCustomerAddress(_ref3) {
  var name = _ref3.name,
      company = _ref3.company,
      address = _ref3.address,
      address2 = _ref3.address2,
      city = _ref3.city,
      state = _ref3.state,
      postalCode = _ref3.postalCode,
      country = _ref3.country,
      vatNo = _ref3.vatNo,
      mainDivision = _ref3.mainDivision,
      vatSignature = _ref3.vatSignature;

  var countryCode = country;
  country = (0, _utils.getCountryName)(countryCode);
  var address1 = address;

  return {
    types: [UPDATE_ADDRESS, UPDATE_ADDRESS_SUCCESS, UPDATE_ADDRESS_FAIL],
    promise: function promise(client) {
      return client.put("/v1/payments/customers/address", {
        data: _ramda2.default.pickBy(_ramda2.default.complement(_ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil)), (0, _extends3.default)({
          name: name,
          company: company,
          address1: address1,
          address2: address2,
          postalCode: postalCode,
          country: country,
          city: city,
          state: state,
          countryCode: countryCode
        }, mainDivision && { mainDivision: mainDivision }, vatNo && {
          vatNo: vatNo
        }, vatSignature && {
          vatSignature: vatSignature
        }))
      });
    }
  };
}

function createOrUpdateCustomer(values) {
  return function (dispatch, getState) {
    if (getState().customer.customer) {
      return dispatch(updateCustomer(values));
    }

    return dispatch(createCustomer(values));
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/customer.js
// module id = 122
// module chunks = 0